/* cl-massfinder.js – Maßfinder Startseite Isoliershophuber (Claude, 18.10.2026)
   Logik übernommen aus dem Isolierpilot-Maßfinder (ip-massfinder.liquid, V2),
   für Huber umgebaut (19.10.: Brandschutz-Kachel, Metafelder wie Isolierpilot): Messhilfe-Querschnitt, Blechmantel mit passendem
   Zubehör, Beratung bei fehlender Größe.
   Liest die Varianten aus den Optionswerten (z. B. "22/12 mm", "13/22 mm",
   "Ø Durchmesser Innen" + "Dämmstärke"). Gepflegte Metafelder
   custom.rohr_ad_von_mm / rohr_ad_bis_mm / daemmdicke_mm / innendurchmesser_mm
   haben Vorrang.
   19.10.2026 (2): Vorauswahl über data-start-art bzw. ?art=&rohr=&daemm=,
   Messung: Ereignis rohr_massfinder_add_to_cart (dataLayer/gtag/Shopify
   Customer Events) und Positions-Eigenschaft _Quelle=Rohr-Maßfinder. */
(() => {
  const num = s => parseFloat(String(s).replace(',', '.'));
  const fmt = n => String(Math.round(n * 10) / 10).replace('.', ',');
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const uniq = a => [...new Set(a)].sort((x, y) => x - y);

  // Rohr-Ø und Dämmstärke aus einer Variante lesen
  function parse(p, v) {
    if (v.r && v.d) return { r: +v.r, rb: v.rb ? +v.rb : null, d: +v.d };
    const on = p.o.map(n => String(n).toLowerCase());
    const ir = on.findIndex(n => /durchmesser innen|innendurchmesser|^rohr/.test(n) && !n.includes('/'));
    const idd = on.findIndex(n => /^dämmstärke/.test(n) && !n.includes('/'));
    if (ir > -1 && idd > -1) {
      const rm = String(v.o[ir]).match(/(\d+(?:[.,]\d+)?)\s*-\s*(\d+(?:[.,]\d+)?)/);
      const r = num(v.o[ir]), d = num(v.o[idd]);
      return isNaN(r) || isNaN(d) ? null : { r, rb: rm ? num(rm[2]) : null, d };
    }
    let ic = on.findIndex(n => n.includes('/') && n.includes('dämm')), aussen = false;
    if (ic < 0) { ic = on.findIndex(n => n.includes('außendurchmesser')); aussen = true; }
    if (ic < 0) return null;
    // Mehrteilige Werte (z. B. „Inhalt/Rohrdurchmesser/Dämmstärke“ = „1/42/30“) nach Namensteilen zuordnen
    const teile = on[ic].split('/').map(s => s.trim()), zahlen = String(v.o[ic]).match(/\d+(?:[.,]\d+)?/g) || [];
    if (teile.length > 1 && zahlen.length === teile.length) {
      const iR = teile.findIndex(s => /rohr|außen/.test(s)), iD = teile.findIndex(s => /dämm/.test(s));
      if (iR > -1 && iD > -1 && iR !== iD) return { r: num(zahlen[iR]), d: num(zahlen[iD]) };
    }
    const m = [...String(v.o[ic]).matchAll(/(\d+(?:[.,]\d+)?)\s*\/\s*(\d+(?:[.,]\d+)?)/g)].pop();
    if (!m) return null;
    const a = num(m[1]), b = num(m[2]);
    const daemmZuerst = !aussen && on[ic].indexOf('dämm') < on[ic].indexOf('rohr');
    return daemmZuerst ? { r: b, d: a } : { r: a, d: b };
  }

  const material = t => (/alumin/i.test(t) ? 'Aluminium' : /edelstahl|v2a/i.test(t) ? 'Edelstahl V2A' : /stahl|verzinkt/i.test(t) ? 'Stahl verzinkt' : '');

  function init(box) {
    if (!box || box.dataset.ready) return;
    const src = box.querySelector('[data-cl-mf-daten]');
    let raw;
    try { raw = typeof box.clMfRaw === 'object' ? box.clMfRaw : JSON.parse(src.textContent); }
    catch (e) { box.querySelector('[data-cl-mf-ergebnis]').textContent = 'Der Maßfinder konnte nicht geladen werden.'; return; }
    box.dataset.ready = 1;

    const tel = box.dataset.tel || '', telUrl = box.dataset.telUrl || '';
    const daten = { kautschuk: [], rohrschale: [], brandschutz: [], blech: [], zubehoer: [] };
    const rLabel = {};
    const istBS = t => /conlit|protect|brandschutz/i.test(t);
    ['kautschuk', 'rohrschale', 'brandschutz'].forEach(k => (raw[k] || []).forEach(p => p.v.forEach(v => { const x = parse(p, v); if (x && x.r > 0 && x.d > 0) { if (x.rb) rLabel[x.r] = fmt(x.r) + '–' + fmt(x.rb); daten[k].push({ ...x, p, v }); } })));
    (raw.blech || []).forEach(p => {
      const on = p.o.map(n => String(n).toLowerCase());
      const t = p.t.toLowerCase();
      const istMantel = on[0] === 'innendurchmesser' && /mantel/.test(t) && !/bogen|endteller|stutzen/.test(t);
      const istZubehoer = /bogen|endteller/.test(t) && /durchmesser/.test(on[0] || '') && !/grobkorn/.test(t);
      if (!istMantel && !istZubehoer) return;
      p.v.forEach(v => { const di = v.di ? +v.di : num(v.o[0]); if (!isNaN(di)) (istMantel ? daten.blech : daten.zubehoer).push({ di, mat: material(p.t), p, v }); });
    });

    const selR = box.querySelector('[data-cl-mf-rohr]'), selD = box.querySelector('[data-cl-mf-daemm]');
    const out = box.querySelector('[data-cl-mf-ergebnis]'), hilfe = box.querySelector('[data-cl-mf-daemm-hilfe]');
    const svg = box.querySelector('[data-cl-mf-svg]');
    const art = () => (box.querySelector('input[name="cl-mf-art"]:checked') || {}).value || 'kautschuk';
    const quelle = () => (art() === 'blech' ? [...daten.kautschuk, ...daten.rohrschale] : daten[art()]);
    const opts = (sel, vals) => {
      const old = sel.value;
      sel.innerHTML = vals.map(v => `<option value="${v}">${sel === selR && rLabel[v] ? rLabel[v] : fmt(v)}</option>`).join('');
      if (old && vals.map(String).includes(old)) sel.value = old;
      sel.disabled = !vals.length;
    };

    function fillR() { opts(selR, uniq(quelle().map(x => x.r))); fillD(); }
    function fillD() {
      const r = num(selR.value);
      opts(selD, uniq(quelle().filter(x => x.r === r).map(x => x.d)));
      hilfe.textContent = art() === 'blech' ? 'Dämmung unter dem Blechmantel' : art() === 'brandschutz' ? 'Dämmstärke laut Zulassung' : 'Wandstärke der Dämmung';
      render();
    }

    // Messhilfe: Querschnitt Rohr + Dämmung (+ Blech), maßstäblich gedeckelt
    function zeichne(r, d) {
      if (!svg) return;
      const a = art(), aussen = r + 2 * d;
      const k = 160 / Math.max(aussen, 1);
      const rd = 80, rr = Math.max(16, Math.min(rd - 12, (r / 2) * k));
      const daemmFarbe = a === 'kautschuk' ? '#2b3138' : a === 'brandschutz' ? '#b9b2a6' : '#d9c58a';
      svg.querySelector('[data-k="daemm"]').setAttribute('r', rd);
      svg.querySelector('[data-k="daemm"]').setAttribute('fill', daemmFarbe);
      svg.querySelector('[data-k="rohr"]').setAttribute('r', rr);
      svg.querySelector('[data-k="loch"]').setAttribute('r', Math.max(rr - 5, 6));
      const blech = svg.querySelector('[data-k="blech"]');
      blech.setAttribute('r', rd + 4); blech.style.display = a === 'blech' ? '' : 'none';
      const alu = svg.querySelector('[data-k="alu"]');
      alu.setAttribute('r', rd); alu.style.display = a === 'rohrschale' || a === 'brandschutz' ? '' : 'none';
      const ln = (key, y, x1, x2) => { const l = svg.querySelector(`[data-k="${key}"]`); l.setAttribute('x1', 100 + x1); l.setAttribute('x2', 100 + x2); l.setAttribute('y1', y); l.setAttribute('y2', y); };
      ln('m-rohr', 100, -rr, rr); ln('m-daemm', 100 - rr - (rd - rr) / 2, 0, 0);
      const md = svg.querySelector('[data-k="m-daemm"]'); md.setAttribute('y1', 100 - rd); md.setAttribute('y2', 100 - rr);
      box.querySelector('[data-cl-mf-l-rohr]').textContent = isNaN(r) ? '–' : (rLabel[r] || fmt(r)) + ' mm';
      box.querySelector('[data-cl-mf-l-daemm]').textContent = isNaN(d) ? '–' : fmt(d) + ' mm';
      box.querySelector('[data-cl-mf-l-aussen]').textContent = isNaN(aussen) ? '–' : '≈ ' + fmt(aussen) + ' mm';
    }

    const karte = (x, zeile) => `<li class="cl-mf__hit">
      <a class="cl-mf__hit-img" href="${esc(x.p.u)}?variant=${x.v.id}" tabindex="-1" aria-hidden="true">${x.p.i ? `<img src="${esc(x.p.i)}" alt="" width="72" height="72" loading="lazy">` : ''}</a>
      <div class="cl-mf__hit-text">${istBS(x.p.t) && art() !== 'brandschutz' ? '<span class="cl-mf__badge">Brandschutz</span>' : ''}<a href="${esc(x.p.u)}?variant=${x.v.id}">${esc(x.p.t)}</a><small>${zeile}${x.v.s ? ' · Art.-Nr. ' + esc(x.v.s) : ''}</small></div>
      <div class="cl-mf__hit-buy"><span class="cl-mf__preis">${esc(x.v.p)}<small>inkl. MwSt., zzgl. Versand</small></span>
      ${x.v.a ? `<form action="/cart/add" method="post"><input type="hidden" name="id" value="${x.v.id}"><input type="hidden" name="quantity" value="1"><input type="hidden" name="properties[_Quelle]" value="Rohr-Maßfinder"><button type="submit" class="cl-mf__btn">In den Warenkorb</button></form>` : '<span class="cl-mf__nicht">derzeit nicht verfügbar</span>'}</div></li>`;

    const beratung = text => `<div class="cl-mf__status cl-mf__status--nein">${text}${tel ? ` <a href="${esc(telUrl)}">Fachberatung: ${esc(tel)}</a>` : ''}</div>`;

    function render() {
      const r = num(selR.value), d = num(selD.value);
      zeichne(r, d);
      if (isNaN(r) || isNaN(d)) { out.innerHTML = '<p class="cl-mf__status">Bitte Rohr-Außendurchmesser und Dämmstärke wählen.</p>'; return; }
      if (art() === 'blech') {
        const soll = r + 2 * d, nach = {};
        daten.blech.forEach(x => { if (x.di >= soll && (!nach[x.p.t] || x.di < nach[x.p.t].di)) nach[x.p.t] = x; });
        const liste = Object.values(nach).sort((a, b) => a.mat.localeCompare(b.mat));
        if (!liste.length) { out.innerHTML = beratung(`Für ${fmt(soll)} mm Außendurchmesser führen wir keinen Blechmantel im Shop – Sondergrößen gern auf Anfrage.`); return; }
        const di = Math.min(...liste.map(x => x.di));
        const zub = daten.zubehoer.filter(z => liste.some(m => m.di === z.di && m.mat === z.mat));
        out.innerHTML = `<p class="cl-mf__status cl-mf__status--ok">Passender Blechmantel: Ø innen mindestens ${fmt(soll)} mm <span>(Rohr-Ø + 2 × Dämmstärke)</span></p>
          <ul class="cl-mf__hits">${liste.map(x => karte(x, `${x.mat ? x.mat + ' · ' : ''}Ø innen ${esc(x.v.o[0])}`)).join('')}</ul>
          ${zub.length ? `<div class="cl-mf__zub"><p>Passend dazu in Ø ${fmt(di)}${liste.some(x => x.di !== di) ? '+' : ''} mm</p><ul>${zub.map(z => `<li><a href="${esc(z.p.u)}?variant=${z.v.id}">${esc(z.p.t.replace(/ für Rohrisolierung.*$| Stirnscheibe.*$/i, ''))}</a><span>${esc(z.v.p)}</span></li>`).join('')}</ul></div>` : ''}`;
        return;
      }
      const t = daten[art()].filter(x => x.r === r && x.d === d);
      const hbs = art() === 'brandschutz' && box.dataset.hinweisBs ? `<p class="cl-mf__bs">${esc(box.dataset.hinweisBs)}</p>` : '';
      out.innerHTML = t.length
        ? `<p class="cl-mf__status cl-mf__status--ok">${t.length === 1 ? 'Diese Größe gibt es im Shop' : t.length + ' passende Artikel im Shop'}</p>${hbs}<ul class="cl-mf__hits">${t.slice(0, 8).map(x => karte(x, `${esc(x.v.vt || x.v.o.join(' · '))}`)).join('')}</ul>`
        : beratung('Diese Kombination führen wir nicht im Shop.') + hbs;
    }

    box.querySelectorAll('input[name="cl-mf-art"]').forEach(i => i.addEventListener('change', fillR));
    selR.addEventListener('change', fillD);
    selD.addEventListener('change', render);

    // Messung: Klick auf „In den Warenkorb“ aus dem Maßfinder
    const melde = (name, daten) => {
      try { (window.dataLayer = window.dataLayer || []).push({ event: name, ...daten }); } catch (e) {}
      try { if (typeof window.gtag === 'function') window.gtag('event', name, daten); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, daten); } catch (e) {}
    };
    // Klick statt submit: Warenkorb-Apps (Upcart) fangen submit vorher ab
    let zuletzt = 0;
    const kauf = el => {
      const f = el && el.closest('form');
      if (!f || Date.now() - zuletzt < 1500) return;
      zuletzt = Date.now();
      const id = (f.querySelector('input[name="id"]') || {}).value;
      melde('rohr_massfinder_add_to_cart', { variant_id: id, produktart: art(), rohr_mm: selR.value, daemm_mm: selD.value, herkunft: new URLSearchParams(location.search).get('von') || 'direkt' });
    };
    out.addEventListener('click', e => { const b = e.target.closest && e.target.closest('.cl-mf__btn'); if (b) kauf(b); }, true);
    out.addEventListener('submit', e => kauf(e.target), true);

    // Vorauswahl: data-start-art oder URL ?art=&rohr=&daemm=
    const q = new URLSearchParams(location.search);
    const startArt = q.get('art') || box.dataset.startArt;
    const startRadio = /^[a-z]+$/.test(startArt || '') && box.querySelector(`input[name="cl-mf-art"][value="${startArt}"]`);
    if (startRadio) startRadio.checked = true;
    fillR();
    const setze = (sel, wert, weiter) => { if (wert == null) return; const v = [...sel.options].find(o => num(o.value) === num(wert)); if (v) { sel.value = v.value; weiter(); } };
    setze(selR, q.get('rohr'), fillD);
    setze(selD, q.get('daemm'), render);
  }

  window.clMassfinderInit = init;
  const all = () => document.querySelectorAll('[data-cl-mf]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-cl-mf]')));
})();
